import Vue from 'vue'
import App from './App.vue'
import Vuex from "vuex";
import Vuer from "vue-router";
import helps from "./helpers/";
import https from './services/';
import moment from './dayjs-alias';
import Paginate from 'vue-pagination-2';
import PrimeVue from 'primevue/config';
import Sidebar from 'primevue/sidebar';
import Divider from 'primevue/divider';
import PickList from 'primevue/picklist';
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Button from 'primevue/button';
import ProgressBar from 'primevue/progressbar';
import ImagePreview from "primevue/imagepreview";
import Dialog from 'primevue/dialog';
import Menu from 'primevue/menu';
import Tag from 'primevue/tag'
import Steps from 'primevue/steps';
import SplitButton from 'primevue/splitbutton';
import stores from "./stores";
import routes from "./routes";
import Spinner from 'vue-spinkit';
import { extend, localize } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import _fr from 'vee-validate/dist/locale/fr.json';
import VueLoading from 'vuejs-loading-plugin';
import Vuet from "vue-sweetalert2";
import VueCookies from 'vue-cookies';
import VueToast from 'vue-toast-notification';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import MultiSelect from 'vue-multiselect'
import PMultiSelect from 'primevue/multiselect';
import OverlayPanel from 'primevue/overlaypanel';
import AutoComplete from 'primevue/autocomplete';
import Chart from 'primevue/chart';
import XLSX from "xlsx";
import JsonExcel from "vue-json-excel";
import TabView from 'primevue/tabview';
import TabPanel from 'primevue/tabpanel';
import Calendar from 'primevue/calendar';
import Card from "primevue/card";
import Toolbar from 'primevue/toolbar';
import vSelect from 'vue-select';
import html2pdf from 'html2pdf.js';
import VueSignature from "vue-signature-pad";
import { formatHeuresFormation } from '@/helpers/heuresFormation';

import 'vue-toast-notification/dist/theme-bootstrap.css';
import "vue-select/dist/vue-select.css";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

import 'slick-carousel';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import jQuery from 'jquery';
window.$ = window.jQuery = jQuery;

Vue.prototype.moment = moment;
Vue.prototype.$moment = moment;

Vue.config.devtools = false;

if (process.env.NODE_ENV === 'production') {
  console.log = () => {}
  console.debug = () => {}
}

Vue.config.productionTip = false
Vue.component("Toolbar", Toolbar);
Vue.component("Card", Card);
Vue.component("downloadExcel", JsonExcel);
Vue.component('Calendar', Calendar);
Vue.component('Spinner', Spinner);
Vue.component('Menu', Menu);
Vue.component('Paginate', Paginate);
Vue.component('Sidebar', Sidebar);
Vue.component('Dialog', Dialog);
Vue.component('Button', Button);
Vue.component('Divider', Divider);
Vue.component('ProgressBar', ProgressBar);
Vue.component("ImagePreview", ImagePreview);
Vue.component('SplitButton', SplitButton);
Vue.component('Dropdown', Dropdown)
Vue.component('PMultiSelect', PMultiSelect);
Vue.component('PickList', PickList);
Vue.component('InputText', InputText);
Vue.component('Steps', Steps);
Vue.component('OverlayPanel', OverlayPanel);
Vue.component('AutoComplete', AutoComplete);
Vue.component('Chart', Chart);
Vue.component('Tag', Tag);
Vue.component('TabView', TabView);
Vue.component('TabPanel', TabPanel);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('MultiSelect', MultiSelect);
Vue.component('vSelect', vSelect);
Vue.component('html2pdf', html2pdf);
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.use(VueCookies);
Vue.use(PrimeVue);
Vue.use(Vuer).use(Vuet).use(Vuex).use(VueToast);
Vue.use(VueLoading, {
  dark: true,
  text: 'Un instant . . .',
})

Vue.use(VueSignature);
Vue.filter('formatHeures', formatHeuresFormation);
Vue.config.productionTip = false;


Vue.mixin({
  methods: {
    formatJson(FilterData, JsonData){
      return JsonData.map((v) => FilterData.map((j) => {
        return v[j];
      }))
    },
    exportExcel(data = [], name = "Fichier Excel") {

      var invoicesWS = XLSX.utils.json_to_sheet(data)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, invoicesWS, name) // invoices list is name of Worksheet


      // export Excel file
      XLSX.writeFile(wb, name+'.xlsx')

    },
  },
});




for (const rule of Object.keys(rules)) extend(rule, rules[rule]);

extend('integer', {
  message: 'Ce champ doit être un nombre uniquement'
});

extend('containsUppercase', value => {
  if (/[A-Z]/.test(value)) {
    return true;
  }

  return 'Le champ {_field_} doit contenir au moins une lettre majuscule';
});



extend('codePays', value => {
  if (value.includes("+")) {
    return true;
  }

  return 'Le Pays doit être sélectionné';
});

extend('containsLowercase', value => {
  if (/[a-z]/.test(value)) {
    return true;
  }

  return 'Le champ {_field_} doit contenir au moins une lettre miniscule';
});

extend('containsNumber', value => {
  if (/[0-9]/.test(value)) {
    return true;
  }

  return 'Le champ {_field_} doit contenir au moins un nombre';
});

extend('email', {
  message: 'L\'e-mail doit être une adresse de format conforme'
});

localize(_fr.code, _fr);

const store = new Vuex.Store(stores), router = new Vuer(routes);

// Guard de navigation pour sauvegarder la dernière route visitée et vérifier les permissions
router.beforeEach((to, from, next) => {
    // Utiliser les helpers de vérification
    const { canAccessRoute, getUserRole, isInRoleGroup, isMaintienAJourFromUser, EXPERT_MAINTIEN_ROUTE_WHITELIST } = helps;
    
    // Vérifier si l'utilisateur est connecté
    const token = Vue.$cookies.get('OECCAtoken');
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    
    // Routes qui ne nécessitent pas d'authentification
    const publicRoutes = [
        'home', 'connexion', 'signup', 'forget', 'emailValidation', 'suivre-demande',
        'presentation', 'missions', 'contact', 'formation-list', 'actualite-list',
        'personnes-physiques', 'cga', 'comptables-agrees', 'expert-stagiaire',
        'condition-inscription', 'procedure', 'modele-docmument', 'texte-fondamentaux',
        'mot-du-president', 'assemble-general', 'conseil-ordre', 'comites',
        'commissaire-gouvernement', 'condition-inscription', 'rapport-activite',
        'faq-inscription', 'rechercheProfessionnel', 'orientationStrategique',
        'expert-comptable', 'commissaire-comptes', 'expert-comptable-stagiaire',
        'societe-expert-comptable', 'centre-gestion-agree', 'comptable-agree',
        'expert-comptable-entite', 'organisation-affiliee', 'nous-rejoindre',
        'equipe-dirigeante', 'organigramme', 'politique-confidentialite', 'condition-generale-utilisation',
        'mentions-legales', 'annuaire-service', 'detail-actualite', 'detail-formation',
        'participer', 'DemandeDiff', 'DemandeDiffSociete', 'CorrectionDemande', 'CorrectionDemandeSociete',
        'pageErreur', 'verificationMatricule', 'mediatheque', 'verification', 'verification-certificat', 'questionnaire-public'
    ];
    
    const isPublicRoute = publicRoutes.includes(to.name);
    const isAuthRoute = to.path.startsWith('/auth');
    
    if (token && user.token) {
        // Utilisateur connecté
        if (isAuthRoute) {
            // Si connecté et va vers auth, rediriger vers dashboard approprié
            const userRole = user.role?.libelle;
            if (userRole === 'ADMIN' || userRole === 'ROLE_COMITE' || userRole === 'ADMINISTRATIF') {
                next({ name: 'dashboard' });
            } else if (userRole === 'STAGIAIRE') {
                next({ name: 'tableauDeBord' });
            } else {
                next({ name: 'dashboardOnly' });
            }
            return;
        }
        
        // Vérifier les permissions d'accès à la route
        if (!isPublicRoute && to.meta) {
            const hasAccess = canAccessRoute(to.meta);
            
            if (!hasAccess) {
                // L'utilisateur n'a pas les permissions nécessaires
                const userRole = getUserRole();
                
                // Rediriger vers le dashboard approprié selon le rôle
                if (isInRoleGroup(userRole, 'admin') || isInRoleGroup(userRole, 'comite') || isInRoleGroup(userRole, 'administratif')) {
                    Vue.$toast.open({
                        type: 'error',
                        message: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette page.',
                        position: 'top-right',
                        duration: 5000
                    });
                    next({ name: 'dashboard' });
                } else if (isInRoleGroup(userRole, 'stagiaire')) {
                    Vue.$toast.open({
                        type: 'error',
                        message: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette page.',
                        position: 'top-right',
                        duration: 5000
                    });
                    next({ name: 'tableauDeBord' });
                } else {
                    Vue.$toast.open({
                        type: 'error',
                        message: 'Vous n\'avez pas les permissions nécessaires pour accéder à cette page.',
                        position: 'top-right',
                        duration: 5000
                    });
                    next({ name: 'dashboardOnly' });
                }
                return;
            }
        }

        // Expert sans maintien à jour : accès réservé au parcours maintien (et profil / messages)
        if (!isPublicRoute && token && user.token) {
            const userRole = getUserRole();
            const profilePayload = JSON.parse(localStorage.getItem('userConnectedProfile') || localStorage.getItem('user') || '{}');
            if (isInRoleGroup(userRole, 'expert') && !isMaintienAJourFromUser(profilePayload)) {
                const rg = to.meta && to.meta.requiresRoleGroup;
                const requiresExpert = Array.isArray(rg) ? rg.includes('expert') : rg === 'expert';
                if (requiresExpert && to.name && !EXPERT_MAINTIEN_ROUTE_WHITELIST.has(to.name)) {
                    Vue.$toast.open({
                        type: 'warning',
                        message: 'Veuillez régulariser votre maintien pour accéder à cette page.',
                        position: 'top-right',
                        duration: 5000
                    });
                    next({ name: 'mesMaintien' });
                    return;
                }
            }
        }
        
        // Sauvegarder la route actuelle si ce n'est pas une route publique
        if (!isPublicRoute && to.name !== 'connexion') {
            localStorage.setItem('lastVisitedRoute', JSON.stringify({
                name: to.name,
                path: to.path,
                params: to.params,
                query: to.query,
                timestamp: Date.now()
            }));
        }
        
        next();
    } else {
        // Utilisateur non connecté
        if (isPublicRoute || isAuthRoute) {
            next();
        } else {
            // Sauvegarder la route demandée pour redirection après connexion
            localStorage.setItem('intendedRoute', JSON.stringify({
                name: to.name,
                path: to.path,
                params: to.params,
                query: to.query,
                timestamp: Date.now()
            }));
            
            next({ path: '/auth' });
        }
    }
});

new Vue({
    store,
    router,
    render: h => h(App)
}).$mount('#app')